import React from 'react'
import {
    Row, Col,
    Card, CardBody, CardTitle
} from "reactstrap";
  
const IconTile = (props) => {
    const {name, value, icon, color, cardStyle} = props

    return(
        <Card className="card-stats" style={cardStyle}>
            <CardBody>
                <Row>
                    <Col md="3" >
                    <div className={`icon-medium text-center icon-${color.icon}`}>
                        <i className={`${icon} text-${color.icon}`} />
                    </div>
                    </Col>
                    <Col md="9" className="numbers">
                        <p className="card-category grid-top" style={{textTransform: 'none'}}>{name}</p>
                    </Col>
                </Row>
                <Row>
                    <Col className="numbers">
                        <CardTitle tag="p" className={`text-${color.text} no-wrap`}>{value}</CardTitle>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}
export default IconTile
